// extracted by mini-css-extract-plugin
export var clear = "Search-module--clear--6389f";
export var container = "Search-module--container--f8b4b";
export var hideResults = "Search-module--hideResults--0c5ef";
export var inner = "Search-module--inner--f7697";
export var input = "Search-module--input--2b0d7";
export var results = "Search-module--results--8a6da";
export var search = "Search-module--search--5ff2d";
export var searchIcon = "Search-module--searchIcon--8e723";